<template>
    <div
        id="itb-cart-hover"
        class="card itb-top-tail"
        v-show="closeButtonUnpressed && (isOpen || showCartDialog)"
        @mouseover="displayCart"
        @mouseleave="closeCart"
    >
        <button
            v-if="appParams && appParams.staticTranslations"
            class="itb-mdi-logo"
            @click="toggleIcon"
        >
            <img
                src="/images/times-solid.svg"
                :alt="appParams.staticTranslations['general.submit_button']"
                class="itb-icon itb-paperplane"
            />
        </button>
        <div
            v-if="appParams && appParams.staticTranslations"
            class="itb-cart-hover-body"
        >
            <h3>
                {{ appParams.staticTranslations["carts.your_inquiry"] }}
            </h3>
            <table>
                <tbody>
                    <tr
                        v-for="product in products"
                        class="d-flex align-items-center"
                    >
                        <td>
                            <div
                                class="d-flex flex-row"
                                v-lazy-container="{ selector: 'img' }"
                            >
                                <img
                                    v-if="product.image"
                                    class="itb-cart-img"
                                    v-bind:data-src="
                                        '/uploads/' +
                                        product.image.path +
                                        '/' +
                                        product.image.name
                                    "
                                    v-bind:alt="product.name"
                                />
                                <div
                                    class="d-flex flex-column justify-content-center itb-carthover-product-description"
                                >
                                    <div style="font-weight: 500">
                                        {{ product.name_variant }}
                                    </div>
                                    <div style="font-size: 0.7rem">
                                        {{
                                            appParams.staticTranslations[
                                                "carts.code_label"
                                            ]
                                        }}:
                                        {{ product.graphic_code }}
                                    </div>
                                </div>
                            </div>
                        </td>

                        <td class="ml-auto">x {{ product.quantity }}</td>
                    </tr>
                </tbody>
            </table>
            <button
                type="button"
                class="btn btn-primary itb-add-to-basket itb-carthover-checkout"
                @click="goToCheckout"
            >
                {{ appParams.staticTranslations["carts.checkout_list"] }}&nbsp;
            </button>
        </div>
    </div>
</template>

<script>
import Jwt from "jsonwebtoken";
import { mapGetters } from "vuex";
import { required, email } from "vuelidate/lib/validators";

export default {
    name: "CartHover",
    props: {
        visible: Boolean,
        products: Array,
        cartId: Number,
    },
    data() {
        return {
            client: {
                email: "",
                password: "",
                remember_me: false,
            },

            showCartDialog: false,
            closeButtonUnpressed: true,
        };
    },
    computed: {
        ...mapGetters({
            isLoggedIn: "getClientLogged",
            profile: "getClientProfile",
            appParams: "getAppParams",
        }),
        isOpen: {
            get() {
                return this.visible;
            },
            set(value) {
                if (!value) {
                    this.$emit("close");
                }
            },
        },
    },

    validations: {
        client: {
            password: {
                required,
            },
            email: {
                required,
                email,
            },
        },
    },
    methods: {
        toggleIcon() {
            this.closeButtonUnpressed = false;
            this.showCartDialog = false;
            // this.$emit("toggleStatic");
            this.$emit("close");
            setTimeout(() => {
                this.closeButtonUnpressed = true;
            }, 500);
        },

        displayCart() {
            this.showCartDialog = true;
        },
        closeCart() {
            this.showCartDialog = false;
        },

        goToCheckout() {
            if (this.$route.path != "/cart") {
                this.$router.push("/cart");
            }
            this.$emit("closeNavbar");
            this.toggleIcon();
        },
    },
};
</script>
